if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this.classesToRemoveOnLoad = 'drawer--loading';
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.add(this.classesToRemoveOnLoad);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            // --- VAT: only apply if feature is enabled in theme settings or body attribute ---
            (function runVatIfEnabled(rootEl) {
              try {
                const bodyAttr = document.body && document.body.getAttribute && document.body.getAttribute('data-enable-vat-toggle');
                const bodyFlag = bodyAttr === 'true' ? true : (bodyAttr === 'false' ? false : null);

                const windowFlag =
                  typeof window !== 'undefined' && window.themeSettings && typeof window.themeSettings.enableVatToggle !== 'undefined'
                    ? !!window.themeSettings.enableVatToggle
                    : null;

                const VAT_ENABLED = bodyFlag !== null ? bodyFlag : (windowFlag !== null ? windowFlag : false);

                if (!VAT_ENABLED) {
                  // console.debug('[VAT][quickview] feature disabled — skipping VAT apply.');
                  return;
                }
                // --- VAT: ensure newly-inserted quick-view content shows correct price (robust) ---
                (function applyVatToQuickView(root) {
                  function getCookie(name) {
                    const nameEQ = name + "=";
                    const ca = document.cookie.split(';');
                    for (let i = 0; i < ca.length; i++) {
                      let c = ca[i].trim();
                      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
                    }
                    return null;
                  }

                  function debugStatus(root, mode) {
                    const all = root.querySelectorAll('.f-price');
                    const visibleInc = Array.from(root.querySelectorAll('.f-price--inc')).filter(e => window.getComputedStyle(e).display !== 'none').length;
                    const visibleExc = Array.from(root.querySelectorAll('.f-price--exc')).filter(e => window.getComputedStyle(e).display !== 'none').length;
                    // console.debug('[VAT][quickview][diagnostic] mode:', mode, 'f-price count:', all.length, 'visibleInc:', visibleInc, 'visibleExc:', visibleExc);
                    // show first price markup snapshot (helps debug server vs client rendered)
                    const first = root.querySelector('.f-price');
                    if (first) {
                      // console.debug('[VAT][quickview][first f-price html]', first.innerHTML.trim().slice(0, 400));
                    }
                  }

                  function localApply(root, mode) {
                    // defensive local apply if vatHelpers missing or flaky
                    const INC = 'inc';
                    const incSpans = root.querySelectorAll('.f-price--inc');
                    const excSpans = root.querySelectorAll('.f-price--exc');

                    if (mode === INC) {
                      incSpans.forEach(s => (s.style.display = ''));
                      excSpans.forEach(s => (s.style.display = 'none'));
                    } else {
                      incSpans.forEach(s => (s.style.display = 'none'));
                      excSpans.forEach(s => (s.style.display = ''));
                    }

                    // unit price and label fallbacks
                    root.querySelectorAll('[data-unit-price-inc]').forEach(el => (el.style.display = mode === INC ? '' : 'none'));
                    root.querySelectorAll('[data-unit-price-exc]').forEach(el => (el.style.display = mode === INC ? 'none' : ''));
                    root.querySelectorAll('.vat-label--inc').forEach(el => (el.style.display = mode === INC ? '' : 'none'));
                    root.querySelectorAll('.vat-label--exc').forEach(el => (el.style.display = mode === INC ? 'none' : ''));
                  }

                  try {
                    const rootEl = drawerContent || root; // root passed, fallback to drawerContent
                    const cookieMode = getCookie('vat_display'); // expected 'inc' or 'exc'
                    // if cookie missing, fall back to the server visible span in first price
                    let mode = cookieMode || null;
                    if (!mode) {
                      const firstPrice = rootEl.querySelector('.f-price');
                      if (firstPrice) {
                        const incSpan = firstPrice.querySelector('.f-price--inc');
                        mode = incSpan && window.getComputedStyle(incSpan).display !== 'none' ? 'inc' : 'exc';
                      } else {
                        mode = 'exc';
                      }
                      // console.debug('[VAT][quickview] cookie not found, inferred mode:', mode);
                    } else {
                      // console.debug('[VAT][quickview] cookie mode:', cookieMode);
                    }

                    // Prefer vatHelpers with explicit mode param (applyVatModeToNode(rootEl, mode))
                    if (window.vatHelpers && typeof window.vatHelpers.applyVatModeToNode === 'function') {
                      try {
                        window.vatHelpers.applyVatModeToNode(rootEl, mode);
                        // console.debug('[VAT] applied via vatHelpers with mode:', mode);
                      } catch (e) {
                        // console.warn('[VAT] vatHelpers.applyVatModeToNode threw, falling back to localApply', e);
                        localApply(rootEl, mode);
                      }
                    } else {
                      // dispatch event (existing vat-apply listener may ignore mode), *and* run local fallback*
                      try {
                        document.dispatchEvent(new CustomEvent('vat:apply', { detail: { root: rootEl, mode } }));
                        // console.debug('[VAT] vat:apply event dispatched with mode:', mode);
                      } catch (e) {
                        // console.debug('[VAT] vat:apply event failed', e);
                      }
                      localApply(rootEl, mode);
                      // console.debug('[VAT] localApply executed with mode:', mode);
                    }

                    // microtask + short retry to catch late-inserted nodes or script hydration
                    Promise.resolve().then(() => {
                      try {
                        if (window.vatHelpers && typeof window.vatHelpers.applyVatModeToNode === 'function') {
                          window.vatHelpers.applyVatModeToNode(rootEl, mode);
                        } else {
                          localApply(rootEl, mode);
                        }
                      } catch (e) { /* ignore */ }
                      debugStatus(rootEl, mode);
                    });
                    setTimeout(() => {
                      try {
                        if (window.vatHelpers && typeof window.vatHelpers.applyVatModeToNode === 'function') {
                          window.vatHelpers.applyVatModeToNode(rootEl, mode);
                        } else {
                          localApply(rootEl, mode);
                        }
                      } catch (e) { /* ignore */ }
                      debugStatus(rootEl, mode);
                    }, 200);
                  } catch (err) {
                    // console.warn('[VAT] quick-view apply failed', err);
                  }
                })(drawerContent);
              } catch (err) {
                // console.warn('[VAT][quickview] guard check failed', err);
              }
            })();

            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.remove(this.classesToRemoveOnLoad);
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
